import { render, staticRenderFns } from "./ModelNav.vue?vue&type=template&id=558a0927&"
import script from "./ModelNav.vue?vue&type=script&lang=ts&"
export * from "./ModelNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports